import { ResourceNugget } from '@backrs_ui/grow-ui/src/components/Lubav/nuggets/ResourceNugget';
import { Job, LubavInternship } from '@backrs_ui/grow-ui/src/models/models';

import { Box, Theme, SxProps } from '@mui/material';

const jobDetails: { title: string; key: keyof Job }[] = [
  { title: 'Highlights', key: 'benefits' },
  { title: 'Why this may be a good fit', key: 'goals_fit' },
  { title: 'Why may this may not be a good fit', key: 'goals_discrepency' },
  { title: 'Your qualifications', key: 'qualified' },
  { title: 'Qualification gap', key: 'not_qualified' },
];

const formatSubtext = (job: Job): string => {
  return jobDetails.map(({ title, key }) => `**${title}:** ${job[key] || 'N/A'}`).join('\n\n');
};

export const JobPostingsFormatter = ({ jobPostings }: { jobPostings: Job[] }) => {
  const internships: LubavInternship[] = jobPostings.map((job) => ({
    metadata: job.metadata,
    relevance: formatSubtext(job),
  }));

  return (
    <Box sx={jobPostingsContainerStyles}>
      {internships.map((internship) => (
        <ResourceNugget key={internship.metadata.id} type="internships" resource={internship} />
      ))}
    </Box>
  );
};

const jobPostingsContainerStyles: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
} as const;
